import React from "react";
import { PortHookInterface } from "../portDetailsHook";
import Input from "./Input";
import Button from "../../DesignSystem/button";
import WaveXchangeButton from "./WaveXchangeButton";
import OptionsMenu from "./PortMenu";

interface PortProps {
  portProps: PortHookInterface;
  isBandwidthPage: boolean;
}

const Port: React.FC<PortProps> = ({ portProps, isBandwidthPage }) => {
  const { portDetails: port, editPorts, formHooks, groupService } = portProps;
  if (!port) return <div>Loading...</div>;

  const resetPortButton = (
    <Button
      variant="primary"
      text="Reset"
      onClick={() => editPorts.resetEdits()}
      disabled={!editPorts.isPortNameOrDescriptionChanged || portProps.groupService.GroupDropdownProps.loading}
    />
  );
  const sendEditsButton = (
    <Button
      variant="primary"
      text="Save"
      onClick={() => editPorts.sendEdits()}
      disabled={!editPorts.isPortNameOrDescriptionChanged || portProps.groupService.GroupDropdownProps.loading}
      loading={editPorts.loading}
    />
  );

  if (!portProps.portDetails) return <></>;

  return (
    <div className="port-container">
      <div className="bottom">
        <OptionsMenu portProps={portProps} isBandwidthPage={isBandwidthPage} />
        <Input customForm={groupService.GroupDropdownProps.dropdownComponent} title="Group Name" />
        <Input value={formHooks.name} setValue={formHooks.setName} title="Port Name" onKeypress={editPorts.sendEdits} />
        <Input value={port.port_type} title="Port Type" info="Please contact WaveXchange to change the type of this port" />
        <div className="flex edit-buttons">
          {resetPortButton}
          {sendEditsButton}
        </div>
        <div className="move-to-wx flex">
          <WaveXchangeButton portProps={portProps} />
        </div>
        {!portProps.portDetails.verified && <div style={{ paddingInline: 50, justifyContent: "center", display: "flex" }}>
          {Number(portProps.portDetails.position_in_mmr || 0 > 0) || portProps.portDetails.verified ? (
            <Button variant="search" text={`Position in MMR: ${portProps.portDetails?.position_in_mmr}`} disabled />
          ) : !portProps.portDetails?.request_move_to_mmr && !portProps.portDetails?.requested_verification ? (
            // WV-2453 Action Costs Money
            // Move to MMR cost money
            <Button variant="search" onClick={() => portProps.moveToMMR.requestMoveToMMR()} text="Move to MMR" />
          ) : (
            <Button variant="search" text="Pending Move to MMR" disabled />
          )}
        </div>}
      </div>
    </div>
  );
};
export default Port;
